module.exports = __webpack_public_path__ + "static/media/documents-icon-active.5a0c89f7.svg";